import { graphQuery, gql } from "shared/lib/graphql"

const abandonedCheckoutMutation = gql`
  mutation abandonedCheckoutMutation($plan_id: user_tier_type) {
    userProAbandonedCheckoutEmail(input: { plan_id: $plan_id }) {
      errors {
        attribute
        message
      }
      email_scheduled
    }
  }
`

// Fire and forget - errors are not user-facing
export default function scheduleAbandonedCheckoutEmail(tier) {
  graphQuery(abandonedCheckoutMutation, { plan_id: tier }).catch(() => {})
}
